import MedicationRxItem from './MedicationRxItem'

function MedicationPrescriptions({ active, suspended, canEdit, onEdit, onSuspend, onReload }) {
  const scheduled = active.filter((item) => item.schedule_kind !== 'se_necessario')

  return (
    <section className="med-medical">
      <div className="med-medical-head">
        <h3>Prescrições ativas (visão médica)</h3>
        <span>Estoque atual</span>
      </div>
      {!scheduled.length && <p className="patients-muted">Nenhuma prescrição com horário neste dia.</p>}
      <div className="med-rx-list">
        {scheduled.map((item) => (
          <MedicationRxItem
            key={item.id}
            item={item}
            canEdit={canEdit}
            onEdit={onEdit}
            onSuspend={onSuspend}
            onReload={onReload}
          />
        ))}
      </div>
      {suspended.length > 0 && (
        <div className="med-suspended">
          <h3>Suspensas</h3>
          {suspended.map((item) => (
            <p key={item.id} className="patients-muted">{item.name}{item.suspend_reason ? ` · ${item.suspend_reason}` : ''}</p>
          ))}
        </div>
      )}
    </section>
  )
}

export default MedicationPrescriptions
